import React, { useRef, useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { uploadImage } from '@/query/documents';
import { NotificationContext } from '@/components/Contexts/NotificationContext';
import { TargetBoxForUpload } from '@/components/UploadDropzoneImage/TargetBoxForUpload';
import UploadedPhotoContainer from '@/components/UploadDropzoneImage/UploadedPhotoContainer';
import FileContainerDropzone from '@/components/UploadDropzoneImage/FileContainerDropzone';

const UploadDropzoneImage = ({ setUploadImg, uploadImg }: any) => {
  const { setShowNotification } = useContext(NotificationContext);
  const [photoInfo, setPhotoInfo] = useState();
  const { t } = useTranslation();
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [droppedFiles, setDroppedFiles] = useState<File[]>([]);

  const tryUploadImage = async (img: any): Promise<any> => {
    try {
      setPhotoInfo(img);
      const data = await uploadImage(img, 1200, 1000);
      setUploadImg(data);
    } catch (e: any) {
      console.error(e);
      setShowNotification({
        message: e?.message,
        type: 'error',
        delay: 3000,
      });
      setPhotoInfo(undefined);
    }
  };

  const handleFileDrop = async (item: { files: any }) => {
    if (item) {
      const files = item.files;
      setDroppedFiles(files);
      await tryUploadImage(item.files[0]);
    }
  };

  const handleUploadPhoto = async (event: any): Promise<any> => {
    const img = event.target.files[0];
    await tryUploadImage(img);
  };

  return (
    <>
      <div id="uploadDropzone" className="mt-3" contentEditable="false">
        {/*<DndProvider backend={HTML5Backend}>*/}
        {!photoInfo && droppedFiles.length === 0 && !uploadImg && (
          <TargetBoxForUpload
            onDrop={handleFileDrop}
            fileInputRef={fileInputRef}
            handleUploadPhoto={handleUploadPhoto}
          />
        )}
        {droppedFiles.length > 0 && !photoInfo && (
          <FileContainerDropzone
            files={droppedFiles}
            fileInputRef={fileInputRef}
            handleUploadPhoto={handleUploadPhoto}
          />
        )}
        {(photoInfo || uploadImg) && (
          <UploadedPhotoContainer
            photoInfo={photoInfo}
            fileInputRef={fileInputRef}
            handleUploadPhoto={handleUploadPhoto}
            uploadLogo={uploadImg}
          />
        )}
        {/*</DndProvider>*/}
      </div>
    </>
  );
};

export default UploadDropzoneImage;
